import React from 'react';
import PropTypes from 'prop-types';

import { Autocomplete as MUIAutocomplete } from '@material-ui/lab';

export const Autocomplete = props => <MUIAutocomplete {...props} />;

Autocomplete.propTypes = {
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  filterOptions: PropTypes.func,
  filterSelectedOptions: PropTypes.bool,
  freeSolo: PropTypes.bool,
  fullWidth: PropTypes.bool,
  getOptionLabel: PropTypes.func,
  getOptionSelected: PropTypes.func,
  groupBy: PropTypes.func,
  loading: PropTypes.bool,
  multiple: PropTypes.bool,
  noOptionsText: PropTypes.node,
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
  open: PropTypes.bool,
  options: PropTypes.array,
  popupIcon: PropTypes.node,
  renderGroup: PropTypes.func,
  renderInput: PropTypes.func.isRequired,
  renderOption: PropTypes.func,
  renderTags: PropTypes.func,
  value: PropTypes.any   // eslint-disable-line react/forbid-prop-types
};

export default Autocomplete;
